import { useEffect } from "react";
import "./InativarDesvio.css";

export default function InativarDesvio({
  open,
  titulo,
  descricao,
  onClose,
  onConfirmar,
  onConfirm,
}) {
  if (!open) return null;

  const submit = onConfirmar || onConfirm || (() => {});

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Escape") onClose?.();
    if (e.key === "Enter") submit();
  };

  return (
    <div className="dvwarn-bg" onKeyDown={handleKeyDown}>
      <div className="dvwarn-box" role="dialog" aria-modal="true" aria-label="Inativar desvio">
        <header className="dvwarn-head">
          <h3 className="dvwarn-title">Inativar</h3>
          <button className="dvwarn-x" type="button" onClick={onClose} aria-label="Fechar">x</button>
        </header>

        <div className="dvwarn-body">
          {descricao ? descricao : <>Deseja <strong>inativar</strong> "{titulo || "este item"}"?</>}
        </div>

        <footer className="dvwarn-foot">
          <button className="dvwarn-btn" type="button" onClick={onClose}>Cancelar</button>
          <button className="dvwarn-btn dvwarn-btn-warn" type="button" onClick={submit}>Inativar</button>
        </footer>
      </div>
    </div>
  );
}
